export const userMenu = [
  {
    name: "Home",
    path: "/dashboard",
  },
  {
    name: "Appointments",
    path: "/appointments",
  },
  {
    name: "Profile",
    path: "/profile",
  },
  {
    name: "Doctor",
    path: "/applydoctor",
  },
];

export const adminMenu = [
  {
    name: "Home",
    path: "/dashboard",
  },
  {
    name: "Users",
    path: "/admin/users",
  },
  {
    name: "Doctors",
    path: "/admin/doctors",
  },
];
